import { createContext } from 'react';

// Define the types for the context values
interface UserContextType {
	user: string;
}

interface CartContextType {
	cart: []; // You can replace 'any' with a more specific type if you know the structure of the cart
}

// Create contexts with initial values
const userContext = createContext<UserContextType>({ user: '' });
const CartContext = createContext<CartContextType | null>(null);

export default userContext;
export { CartContext };
